export const getFileUrl = (fileId: string) => {
  return `${import.meta.env.VITE_FILE_API_BASE_URL}/resource/files/${fileId}`;
};
